import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const i = {
  display: "block"
}, E = ({ size: t = 16, useVw: c, useRem: l, color: o, withColor: n, removeClassName: a, disableSSR: m, style: r, ...p }) => {
  const x = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-boke", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), height: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), className: a ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: a ? "" : "32px-åå®¢"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: a ? "" : "normal",
        fill: n ? d(o, 0, "#262933") : "#262933",
        datafollowfill: n ? d(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M4.8 14.8C4.8 8.62 9.82 3.6 16 3.6s11.2 5.007 11.2 11.2c0 3.225-1.365 6.12-3.543 8.157a.9.9 0 1 1-1.23-1.315A9.331 9.331 0 0 0 25.4 14.8c0-5.197-4.213-9.4-9.4-9.4-5.186 0-9.4 4.214-9.4 9.4a9.333 9.333 0 0 0 3.004 6.874.9.9 0 1 1-1.222 1.321A11.133 11.133 0 0 1 4.8 14.8Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M16 10.348a4.252 4.252 0 0 0-4.25 4.25c0 1.13.44 2.15 1.153 2.91a.9.9 0 0 1-1.312 1.233 6.035 6.035 0 0 1-1.642-4.143c0-3.34 2.711-6.05 6.05-6.05 3.34 0 6.05 2.71 6.05 6.05a6.053 6.053 0 0 1-1.638 4.14.9.9 0 1 1-1.319-1.226 4.253 4.253 0 0 0 1.158-2.914 4.252 4.252 0 0 0-4.25-4.25Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "m20.097 22.88-1.557-1.936c-1.295-1.637-3.78-1.63-5.081-.002l-1.56 1.94-.003.003c-1.703 2.136-.196 5.299 2.547 5.299h3.112c2.732 0 4.27-3.17 2.543-5.304Zm-5.233-.814a1.448 1.448 0 0 1 2.266-.004l.005.007 1.561 1.94.002.003c.765.945.092 2.372-1.143 2.372h-3.112c-1.225 0-1.908-1.412-1.14-2.376l1.56-1.939.001-.003Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, g = E;
export {
  g as default
};
